import(/* webpackMode: "eager" */ "/home/runner/work/waitlistly/waitlistly/src/app/(marketing)/terms/page.tsx");
